/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Anmelden`
};

const en_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Sign in`
};

const es_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Abrir sesión`
};

const fr_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Se connecter`
};

const it_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Effettua il login`
};

const nl_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Aanmelden`
};

const pt_profile__login = /** @type {(inputs: {}) => string} */ () => {
	return `Iniciar sessão`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__login = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__login(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__login", locale)
	if (locale === "de") return de_profile__login(inputs)
	if (locale === "en") return en_profile__login(inputs)
	if (locale === "es") return es_profile__login(inputs)
	if (locale === "fr") return fr_profile__login(inputs)
	if (locale === "it") return it_profile__login(inputs)
	if (locale === "nl") return nl_profile__login(inputs)
	return pt_profile__login(inputs)
};